import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { ItemTypes } from './itemTypes';
export const DragItem = ({ children, id, canDrag = true, canDrop = true, moveItem, findItem }) => {
    const ref = useRef(null);
    const originalIndex = findItem(id);
    const [{ handlerId }, drop] = useDrop({
        accept: ItemTypes.LIST_ITEM,
        canDrop: () => canDrop,
        collect: (monitor) => ({
            handlerId: monitor.getHandlerId()
        }),
        hover(item) {
            if (item.id !== id) {
                const overIndex = findItem(id);
                moveItem(item.id, overIndex);
            }
        }
    });
    const [{ isDragging }, drag, preview] = useDrag({
        type: ItemTypes.LIST_ITEM,
        item: { id, originalIndex },
        canDrag,
        end: (item, monitor) => {
            const didDrop = monitor.didDrop();
            if (item && !didDrop) {
                moveItem(item.id, item.originalIndex);
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    });
    drag(drop(ref));
    if (typeof children === 'function') {
        return children({ ref, handlerId, isDragging, preview });
    }
    return React.createElement("div", { ref: ref }, children);
};
